export default function SumOneDayDate(date){
        return new Date(date.setDate(date.getDate() + 1));
}